// ═══════════════════════════════════════════════════════════════
// TABLA GENÉRICA DE REPORTE
// Archivo: components/ReportTable.jsx
// ═══════════════════════════════════════════════════════════════

import React from 'react';

const fmt = (value) =>
  parseFloat(value || 0).toLocaleString('es-DO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const fmtInt = (value) =>
  parseInt(value || 0).toLocaleString('es-DO');

function CellValue({ col, value }) {
  if (col.money)   return <span>RD$ {fmt(value)}</span>;
  if (col.integer) return <span>{fmtInt(value)}</span>;
  return <span>{value != null ? String(value) : '—'}</span>;
}

export default function ReportTable({ columns = [], data = [], summary = null }) {
  if (!columns.length) return null;

  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200">
      <table className="min-w-full text-sm">
        {/* Cabecera */}
        <thead>
          <tr className="bg-blue-800 text-white">
            {columns.map(col => (
              <th
                key={col.key}
                className={`px-3 py-2.5 font-semibold whitespace-nowrap text-xs tracking-wide
                  ${col.money || col.integer ? 'text-right' : col.align === 'center' ? 'text-center' : 'text-left'}`}
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>

        {/* Cuerpo */}
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="px-4 py-8 text-center text-gray-400 italic bg-gray-50"
              >
                Sin resultados para los filtros seleccionados
              </td>
            </tr>
          ) : (
            data.map((row, idx) => (
              <tr
                key={idx}
                className={`border-b border-gray-100 hover:bg-blue-50 transition-colors
                  ${idx % 2 === 1 ? 'bg-gray-50' : 'bg-white'}`}
              >
                {columns.map(col => (
                  <td
                    key={col.key}
                    className={`px-3 py-2 text-gray-800
                      ${col.money || col.integer ? 'text-right tabular-nums' : col.align === 'center' ? 'text-center' : 'text-left'}`}
                  >
                    <CellValue col={col} value={row[col.key]} />
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>

        {/* Fila de totales */}
        {summary && data.length > 0 && (
          <tfoot>
            <tr className="bg-blue-900 text-white font-bold border-t-2 border-blue-700">
              {columns.map(col => (
                <td
                  key={col.key}
                  className={`px-3 py-2.5 text-xs
                    ${col.money || col.integer ? 'text-right tabular-nums' : col.align === 'center' ? 'text-center' : 'text-left'}`}
                >
                  <CellValue col={col} value={summary[col.key]} />
                </td>
              ))}
            </tr>
          </tfoot>
        )}
      </table>

      {/* Contador */}
      {data.length > 0 && (
        <div className="px-3 py-2 bg-gray-50 border-t border-gray-200 text-xs text-gray-500 text-right">
          {data.length.toLocaleString('es-DO')} registro{data.length !== 1 ? 's' : ''}
        </div>
      )}
    </div>
  );
}
